// extracted by mini-css-extract-plugin
module.exports = {"image":"_9330de7794--image--ExCF3"};